import React, { useState } from 'react'
import { format, parse } from 'date-fns';

import ArrowRightIcon from "../../../../assets/images/explore/common/arrow-big-right.svg";
import InvitationTimer from '../../../../components/invitations/InvitationTimer';
import Modal from '../../../../components/modals/common/Modal';
import CloseIcon from "../../../../assets/images/common/modals/close.svg";
import { useQuery } from 'react-query';
import { getPalateDiscoveryAssignment } from '../../../../actions/palateDiscovery/common';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { palateDiscoveryLinks } from '../../../../utils/internalLinks';
import get from "lodash/get";
import InfoIconBlack from '../../../../assets/images/collaborations/pr/manage/status/infoBlack.svg';


const Header = ({ isModal, handleClose, title, sub_title, icon }) => {
    return (
        <header>
            {icon && <img src={icon} alt="palate-logo" height={"48px"} className='header-img'/>}
            <div className='header__info'>
                {title && <h5>{title}</h5>}
                {sub_title && <p>{sub_title}</p>}
            </div>
            {isModal &&
                <button
                    type="button"
                    className="default-modal__header__close"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleClose();
                    }}
                >
                    <img src={CloseIcon} alt="close modal" />
                </button>}
        </header>
    )
};

const Footer = ({ isModal, isDisabled, testLink, testStatus, handleDismiss }) => {
    if (isModal) {
        return (
            <footer className='default-modal__footer1 default-modal__footer1--multi default-modal__footer1--bottom'>
                <button className='button secondary' onClick={() => handleDismiss()}>Maybe Later </button>
                {testLink && <Link
                    className={`button primary ${isDisabled ? 'disabled' : ''}`}
                    onClick={(e) => {
                        if (isDisabled) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        handleDismiss();
                    }}
                    to={testLink}
                >
                    {testStatus}
                </Link>}
            </footer>
        )
    }
    return (
        <footer>
            {testLink && <Link
                className={`button primary ${isDisabled ? 'disabled' : ''}`}
                to={testLink}
                onClick={(e) => {
                    if (isDisabled) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }}
            >
                {testStatus} <img src={ArrowRightIcon} alt="start-test" />
            </Link>}
        </footer>
    )
}

const Content = ({ isModal, assignmentInfo, handleClose, handleDismiss }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const tasterTypeData = get(assignmentInfo, "result", null);

    if (tasterTypeData) {
        return <div>
            <div className='palate-discovery__card feed-list__item'>
                <Header isModal={isModal} {...assignmentInfo} handleClose={handleClose} />
                <main>
                   {get(assignmentInfo, "review" , null) && <p className="review">
                        <img src={InfoIconBlack} className="img" style={{marginTop: "4px"}} />
                        <div className='under__review-container'>
                            <span className="title">{get(assignmentInfo, "review.title", null)}</span>
                            <p className="subtitle">{get(assignmentInfo, "review.sub_title", null)}</p>
                        </div>
                    </p>}
                    <p className='result'>
                        <span className="title">{get(assignmentInfo, "result.title", null)}</span>
                        <span className="taster-type" style={{
                            borderColor: get(assignmentInfo, "result.taster_type.tint_color", null),
                            color: get(assignmentInfo, "result.taster_type.tint_color", null)
                        }}>
                            <img src={get(assignmentInfo, "result.taster_type.icon", null)} className="img" />
                            {get(assignmentInfo, "result.taster_type.value", null)}
                        </span>
                        <span className="subtitle">{get(assignmentInfo, "result.taster_type.helper", null)}</span>
                    </p>
                </main>
            </div>
        </div>
    }
    const { instructions = [], assignment = {}} = assignmentInfo;
    const expiresAt = assignment.expires_at || "";
    const parsed = expiresAt ? parse(expiresAt, 'yyyy-MM-dd HH:mm:ss', new Date()) : null;;
    const date = parsed ? format(parsed, 'yyyy-MM-dd') : null; // "2025-10-15"
    const time = parsed ? format(parsed, 'HH:mm:ss') : null;   // "11:56:48"
    const testLink = assignment.id ? palateDiscoveryLinks.test(assignment.id) : null;
    const testStatus = get(assignment, "application_status", false) === 3 ? 'RESUME TEST' : 'START TEST';

    return (
        <div className='palate-discovery__card feed-list__item'>
            <Header isModal={isModal} {...assignmentInfo} handleClose={() => handleClose(assignment.id)} />
            <main className='palate-discovery__card--content'>
                <ul className='list-unstyled card--content__list'>
                    {instructions.map(item => <li>{item}</li>)}
                </ul>
                <InvitationTimer
                    date={date}
                    reportingTime={time}
                    title="Test Expire In:"
                    isPalateDiscovery
                    handleUpdate={() => setIsDisabled(true)}
                />
            </main>
           <Footer isModal={isModal} isDisabled={isDisabled} testLink={testLink} testStatus={testStatus} handleDismiss={() => handleClose(assignment.id)} />
        </div>
    )
}


function PalateDiscoveryTest({ isModal, token, assignmentInfoFromFeed, handleClose}) {
    // api will call in modal palate discovery test
    const { data } = useQuery({
        queryKey: ['palateDiscovery'],
        queryFn: () => getPalateDiscoveryAssignment(token),
        enabled: !!(token && !assignmentInfoFromFeed),
        keepPreviousData: true,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    });
    
    const assignmentInfo = assignmentInfoFromFeed ? assignmentInfoFromFeed : data ? data : null;

    if (!assignmentInfo) return null;

    if (isModal) {
        return (
            <Modal className="palate-discovery__card--modal" isCentered>
                <Content isModal assignmentInfo={assignmentInfo} handleClose={handleClose} />
            </Modal>
        )
    }
    return (
        <Content assignmentInfo={assignmentInfo} />
    )
};

export default PalateDiscoveryTest;